import classNames from "classnames";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import styles from "./Article.module.scss";

export type ArticleProps = {
  title: string;
  content: string;
  containerStyle?: string;
};

export const Article = ({ title, content, containerStyle }: ArticleProps) => (
  <div className={classNames(styles.container, containerStyle)}>
    <h2 className={styles.title}>{title}</h2>
    <div
      className={styles.description}
      dangerouslySetInnerHTML={injectPurifiedHTML(removeEmptyRel(content))}
    />
  </div>
);
